import { FormNumericInput } from '@/src/components/Form/FormNumericInput'
import { FormSelect } from '@/src/components/Form/FormSelect'
import { appColors } from '@/src/theme'
import { FlexCol } from '@components'
import type { FormikProps } from 'formik'
import { useTranslation } from 'react-i18next'
import {
  ANNUAL_PRODUCTION_UNITS,
  type LoadPlanningAdjustmentFormEmptyable,
  RENEWABLE_SOURCE_PROFILES,
} from './LoadPlanningAdjustment.types'

interface RenewableProductionAdjustmentFormProps {
  formik: FormikProps<LoadPlanningAdjustmentFormEmptyable>
}

export const RenewableProductionAdjustmentForm = ({ formik }: RenewableProductionAdjustmentFormProps) => {
  const { t } = useTranslation()

  return (
    <FlexCol gap='16px' width='100%'>
      <FormSelect
        isRequired={true}
        name='sourceProfile'
        label={t('components.procurement.forecasting.modal.source_profile')}
        value={formik.values.sourceProfile}
        onChange={val => formik.setFieldValue('sourceProfile', val)}
        options={RENEWABLE_SOURCE_PROFILES.map(profile => ({
          value: profile,
          label: t(`components.procurement.forecasting.modal.source_profile_options.${profile.toLowerCase()}`),
        }))}
        placeholder={t('components.procurement.forecasting.modal.type_placeholder')}
        labelProps={{
          fontWeight: 86,
          fontSize: '14px',
          color: appColors.secondaryForeground,
        }}
      />
      <FormNumericInput
        isRequired={true}
        name='totalAnnualProduction'
        label={t('components.procurement.forecasting.modal.annual_production')}
        infoTooltip={t('components.procurement.forecasting.modal.annual_production_tooltip')}
        labelFontSize={'14px'}
        labelFontColor={appColors.secondaryForeground}
        value={formik.values.totalAnnualProduction}
        onChange={(_value, _name, meta) => formik.setFieldValue('totalAnnualProduction', meta.float ?? undefined)}
        labelRight={formik.values.totalAnnualProductionUnit}
        labelRightOptions={ANNUAL_PRODUCTION_UNITS}
        onLabelRightChange={unit => formik.setFieldValue('totalAnnualProductionUnit', unit)}
        placeholder='0'
        width={'full'}
        textAlign={'right'}
        min={0}
      />
    </FlexCol>
  )
}
